import gsap from 'gsap'
import { addStaticSplideClasses, callAfterResize, connectSplideBullets, pauseVideos, sel, selAll, splideAutoWidth } from './utils'
import 'vidstack/player/styles/default/theme.css'
import 'vidstack/player/styles/default/layouts/video.css'
// import 'vidstack/player/styles/base.css'
// import 'vidstack/player/styles/plyr/theme.css'
import { VidstackPlayer, VidstackPlayerLayout, PlyrLayout } from 'vidstack/global/player'
import Splide from '@splidejs/splide'
import '@splidejs/splide/css'

pauseVideos()
export default function SignupVideo() {
  const container$ = sel('.page-wrapper')
  const sec$a = selAll('.signup__slider__c')

  sec$a.forEach(async (sec$) => {
    // const playerW$ = sec$.querySelector('.join__img__img-w')
    // const playerBg$ = playerW$.querySelector('video')
    const modW$ = sec$.querySelector('.mod-w')
    const mod$ = sec$.querySelector('.mod')
    const close$ = sec$.querySelector('.mod__x-w')
    const bg$ = sec$.querySelector('.mod-bg')

    const _player = sec$.querySelector('.custom_player')
    const player = await VidstackPlayer.create({
      target: _player,
      // src: 'youtube/4UgnVc7kRxE',
      // src: 'vimeo/1061484821',
      // poster: 'https://cdn.prod.website-files.com/655b9a852f3d2a5de3c90048/67ec2aaf454cc0ab8e781425_hero_q85.webp',
      crossOrigin: true,
      playsInline: true,
      viewType: 'video',
      load: 'idle',
      layout: new VidstackPlayerLayout(),
    })

    modW$.classList.add('display-hide')
    container$.appendChild(modW$)

    const tl = gsap
      .timeline({ defaults: { duration: 1, ease: 'power4.inOut' }, paused: true })
      .to(
        {},
        {
          onStart: () => {
            modW$.classList.remove('display-hide')
          },
          onReverseComplete: () => {
            modW$.classList.add('display-hide')
          },
          duration: 0.1,
        }
      )
      .to(modW$, { opacity: 1 })
      .from(mod$, { y: 50 }, 0)

    const closeModal = (e) => {
      e?.stopImmediatePropagation()
      tl.reverse()
      // playerBg$.play()
      player.pause()
    }

    sec$.onclick = (e) => {
      // console.log('pl', player.state.canPlay)
      tl.play()
      // playerBg$.pause()

      if (player.state.canPlay) {
        player.play()
      } else {
        player.addEventListener(
          'can-play',
          (event) => {
            // console.log('canplay')
            player.play()
          },
          { once: true }
        )
      }
    }
    ;[close$, bg$].forEach((el) => {
      el.onclick = closeModal
    })

    player.addEventListener('ended', (event) => {
      closeModal()
    })
  })

  callAfterResize(() => closeModal())

  // Slider
  function sliderInit() {
    const prefix = 'signup'
    const el = '.' + prefix + '__slider'
    if (!sel(el)) return
    addStaticSplideClasses(el)

    const slider = new Splide(el, {
      arrows: false,
      pagination: false,
      type: 'fade',
      gap: '0px',
      perPage: 1,
      // loop: true,
      rewind: true,
      speed: 2500,
      autoplay: 'true',
      // easing: 'cubic-bezier(0.16, 1, 0.3, 1)',
    }).mount()
    // connectSplideArrows(slider, prefix + '__arrows', '.round-arrow')
    connectSplideBullets(slider, prefix + '__slider__bullets')
  }
  // sliderInit()
}
